(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    (function () {
    var desktopQuery = window.matchMedia('(min-width: 1024px)');

    function getSection(block) {
      return block.closest('[data-product-section]') || block.closest('.main-product');
    }

    function placeBlock(block) {
      var section = getSection(block);
      if (!section) return;

      if (desktopQuery.matches) {
        var accordion = section.querySelector('.main-product__accordion');

        if (accordion && accordion.parentElement && accordion.nextElementSibling !== block) {
            accordion.insertAdjacentElement('afterend', block);
        }

        return;
        }

      var videoSlider = section.querySelector('[data-cham-pvs-block]');

      if (videoSlider && videoSlider.parentElement && videoSlider.nextElementSibling !== block) {
        videoSlider.insertAdjacentElement('afterend', block);
        return;
      }

      var shippingNote = section.querySelector('.main-product__shipping-note');

      if (shippingNote && shippingNote.parentElement && shippingNote.nextElementSibling !== block) {
        shippingNote.insertAdjacentElement('afterend', block);
      }
    }

    function setCartCountEverywhere(count) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count], #CartCount, #cart-count').forEach(function (element) {
        element.textContent = String(count);
      });
    }

    function dispatchCartEvents(cart) {
      var detail = { cart: cart, count: cart.item_count };

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    }

    function addButtonHandlers(block) {
      block.querySelectorAll('[data-vm-fbt-atc]').forEach(function (button) {
        if (button.getAttribute('data-vm-fbt-bound') === 'true') return;
        button.setAttribute('data-vm-fbt-bound', 'true');

        button.addEventListener('click', function () {
          if (button.disabled) return;

          var variantId = parseInt(button.getAttribute('data-vm-fbt-variant-id'), 10);
          if (!variantId) return;

          var normalLabel = button.getAttribute('data-vm-fbt-label') || button.textContent;
          var loadingLabel = button.getAttribute('data-vm-fbt-loading-label') || normalLabel;
          var addedLabel = button.getAttribute('data-vm-fbt-added-label') || normalLabel;

          button.classList.add('is-loading');
          button.textContent = loadingLabel;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Unable to add this product.');
              return fetch('/cart.js', {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                cache: 'no-store'
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error('Unable to refresh cart.');
              return response.json();
            })
            .then(function (cart) {
              setCartCountEverywhere(cart.item_count);
              dispatchCartEvents(cart);

              document.dispatchEvent(new CustomEvent('vm-fbt:cart-added', {
                detail: { cart: cart }
              }));

              button.textContent = addedLabel;

              window.setTimeout(function () {
                button.textContent = normalLabel;
              }, 1400);
            })
            .catch(function () {
              button.textContent = normalLabel;
            })
            .finally(function () {
              button.classList.remove('is-loading');
            });
        });
      });
    }

    function initFrequentlyBoughtTogether() {
      document.querySelectorAll('[data-vm-fbt-block]').forEach(function (block) {
        placeBlock(block);
        addButtonHandlers(block);
      });
    }

    initFrequentlyBoughtTogether();
    document.addEventListener('DOMContentLoaded', initFrequentlyBoughtTogether);
    document.addEventListener('shopify:section:load', initFrequentlyBoughtTogether);
    document.addEventListener('shopify:block:select', initFrequentlyBoughtTogether);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', initFrequentlyBoughtTogether);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(initFrequentlyBoughtTogether);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["google-preferred-source"] && !Shopify.designMode) return;
  try {
    (function () {
    var SRC = 'https://news.google.com/swg/js/v1/publisher.js';

    function loadPublisher() {
      if (document.querySelector('script[data-gps-loader]')) return;
      var script = document.createElement('script');
      script.async = true;
      script.src = SRC;
      script.setAttribute('data-gps-loader', '');
      document.head.appendChild(script);
    }

    /* Google decides whether to render at all. Height is the honest signal:
       it covers both an injected button and an iframe that fills in later. */
    function watchMount(block) {
      var box = block.querySelector('[data-gps-btn]');
      if (!box) return;

      function mounted() {
        if (box.offsetHeight <= 0) return false;
        block.classList.add('is-ready');
        return true;
      }

      if (mounted()) return;

      var observers = [];
      function stop() {
        for (var i = 0; i < observers.length; i++) observers[i].disconnect();
      }
      function check() {
        if (mounted()) stop();
      }

      var mutation = new MutationObserver(check);
      mutation.observe(box, { childList: true, subtree: true, attributes: true });
      observers.push(mutation);

      if ('ResizeObserver' in window) {
        var resize = new ResizeObserver(check);
        resize.observe(box);
        observers.push(resize);
      }
    }

    function activate(block) {
      if (block.hasAttribute('data-gps-active')) return;
      block.setAttribute('data-gps-active', '');
      watchMount(block);

      if (!('IntersectionObserver' in window)) {
        loadPublisher();
        return;
      }

      /* A block inside a container the tool has not unhidden yet has no box,
         so this stays quiet until the result appears and scrolls into view. */
      var viewport = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            viewport.disconnect();
            loadPublisher();
            return;
          }
        }
      }, { rootMargin: '400px 0px' });

      viewport.observe(block);
    }

    function waitFor(block, selector) {
      var pending = new MutationObserver(function () {
        if (!document.querySelector(selector)) return;
        pending.disconnect();
        activate(block);
      });
      pending.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['hidden', 'class', 'style'],
      });
    }

    function init() {
      var blocks = document.querySelectorAll('[data-gps-block]');

      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var selector = block.getAttribute('data-gps-reveal-when');
        if (!selector || document.querySelector(selector)) {
          activate(block);
        } else {
          waitFor(block, selector);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reels"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var AUTOPLAY_MS = 3500;
    var NUDGE_PAUSE_MS = 8000;

    function step(track) {
      var card = track.querySelector('[data-product-reel]');
      return card ? card.getBoundingClientRect().width + 10 : track.clientWidth / 3;
    }

    /* The viewer replays whatever source the browser already chose for the rail,
       so opening a reel starts from a warm cache rather than a fresh fetch. */
    function sourceOf(video) {
      if (video.currentSrc) return video.currentSrc;
      if (video.src) return video.src;
      var source = video.querySelector('source');
      return source ? source.src : '';
    }

    function itemsFrom(track) {
      return Array.prototype.slice
        .call(track.querySelectorAll('[data-product-reel]'))
        .map(function (card) {
          var video = card.querySelector('video');
          if (!video) return null;
          return {
            src: sourceOf(video),
            poster: video.getAttribute('poster') || '',
            label: card.getAttribute('data-reel-label') || '',
          };
        })
        .filter(function (item) {
          return item && item.src;
        });
    }

    function initRail(root) {
      if (root.dataset.reelsReady === 'true') return;
      root.dataset.reelsReady = 'true';

      var track = root.querySelector('[data-product-reels-track]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-product-reel]'));
      var hovering = false;
      var railInView = false;
      var pauseUntil = 0;

      // Three cards fill the row on desktop and two on a phone, so the same rail
      // can overflow at one width and fit at another. Ask the track.
      function syncArrows() {
        root.setAttribute('data-scrollable', track.scrollWidth - track.clientWidth > 4 ? 'true' : 'false');
      }
      syncArrows();
      window.addEventListener('resize', syncArrows);

      root.addEventListener('mouseenter', function () {
        hovering = true;
      });
      root.addEventListener('mouseleave', function () {
        hovering = false;
      });
      track.addEventListener(
        'pointerdown',
        function () {
          pauseUntil = Date.now() + NUDGE_PAUSE_MS;
        },
        { passive: true }
      );

      root.addEventListener('click', function (event) {
        var arrow = event.target.closest('[data-product-reels-step]');
        if (arrow) {
          pauseUntil = Date.now() + NUDGE_PAUSE_MS;
          track.scrollBy({
            left: Number(arrow.getAttribute('data-product-reels-step')) * step(track),
            behavior: 'smooth',
          });
          return;
        }

        var card = event.target.closest('[data-product-reel]');
        if (!card || !window.ChamReels) return;
        window.ChamReels.open(itemsFrom(track), cards.indexOf(card));
      });

      if (!('IntersectionObserver' in window)) return;

      // Muted autoplay on every card at once decodes streams nobody is looking
      // at, which is what makes video rails expensive on mid-range phones.
      var playObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.intersectionRatio >= 0.6) video.play().catch(function () {});
            else video.pause();
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      cards.forEach(function (card) {
        playObserver.observe(card);
      });

      new IntersectionObserver(
        function (entries) {
          railInView = entries[0].isIntersecting;
        },
        { threshold: 0.3 }
      ).observe(root);

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (cards.length <= 3 || reduced) return;

      setInterval(function () {
        if (hovering || document.hidden || !railInView || Date.now() < pauseUntil) return;
        if (document.querySelector('.cham-reelviewer[data-open="true"]')) return;

        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(track), behavior: 'smooth' });
      }, AUTOPLAY_MS);
    }

    function init() {
      document.querySelectorAll('[data-product-reels]').forEach(initRail);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reel-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.ChamReels) return;

    /* Translated in Liquid, handed over through the JSON tag above. The
       fallbacks only matter if that tag is missing, which would mean the
       snippet's markup half was edited out from under this one. */
    var LABELS = {
      dialog: 'Product videos',
      close: 'Close videos',
      mute: 'Mute video',
      unmute: 'Unmute video',
      previous: 'Previous video',
      next: 'Next video',
    };

    var labelTag = document.querySelector('.cham-reelviewer-labels');
    if (labelTag) {
      try {
        Object.assign(LABELS, JSON.parse(labelTag.textContent));
      } catch (error) {
        /* keep the fallbacks */
      }
    }

    var ICONS = {
      close: '<path d="M18 6 6 18M6 6l12 12"/>',
      up: '<path d="m18 15-6-6-6 6"/>',
      down: '<path d="m6 9 6 6 6-6"/>',
      sound: '<path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/>',
      muted: '<path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="m17 9 4 6M21 9l-4 6"/>',
    };

    function icon(name) {
      return (
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        ICONS[name] +
        '</svg>'
      );
    }

    function button(className, name, label) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'cham-reelviewer__btn ' + className;
      el.innerHTML = icon(name);
      el.setAttribute('aria-label', label);
      return el;
    }

    var viewer = {
      root: null,
      feed: null,
      index: 0,
      muted: false,
      items: [],
      lastFocus: null,
      observer: null,

      /* The overlay is built once, on first open, and reused from then on. */
      mount: function () {
        if (this.root) return;

        var self = this;
        var root = document.createElement('div');
        root.className = 'cham-reelviewer';
        root.setAttribute('data-open', 'false');
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-label', LABELS.dialog);

        var feed = document.createElement('div');
        feed.className = 'cham-reelviewer__feed';
        root.appendChild(feed);

        var close = button('cham-reelviewer__close', 'close', LABELS.close);
        var mute = button('cham-reelviewer__mute', 'sound', LABELS.mute);
        var prev = button('cham-reelviewer__prev', 'up', LABELS.previous);
        var next = button('cham-reelviewer__next', 'down', LABELS.next);
        var count = document.createElement('span');
        count.className = 'cham-reelviewer__count';

        root.appendChild(close);
        root.appendChild(mute);
        root.appendChild(prev);
        root.appendChild(next);
        root.appendChild(count);
        document.body.appendChild(root);

        this.root = root;
        this.feed = feed;
        this.muteBtn = mute;
        this.countEl = count;
        this.prevBtn = prev;
        this.nextBtn = next;

        close.addEventListener('click', function () {
          self.close();
        });
        mute.addEventListener('click', function () {
          self.toggleMute();
        });
        prev.addEventListener('click', function () {
          self.step(-1);
        });
        next.addEventListener('click', function () {
          self.step(1);
        });
        root.addEventListener('click', function (event) {
          if (event.target === root || event.target === feed) self.close();
        });

        // The feed itself never scrolls the page behind it, but a slide that has
        // not been snapped to yet can still bubble a wheel event to <body> on
        // browsers without overscroll-behavior. Locking the body covers those.
        document.addEventListener('keydown', function (event) {
          if (!self.isOpen()) return;
          if (event.key === 'Escape') self.close();
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            self.step(1);
          }
          if (event.key === 'ArrowUp') {
            event.preventDefault();
            self.step(-1);
          }
        });
      },

      isOpen: function () {
        return !!this.root && this.root.getAttribute('data-open') === 'true';
      },

      slides: function () {
        return this.feed ? Array.prototype.slice.call(this.feed.children) : [];
      },

      video: function () {
        var slide = this.slides()[this.index];
        return slide && slide.querySelector('video');
      },

      build: function (items) {
        var self = this;
        var key = items
          .map(function (item) {
            return item.src;
          })
          .join('|');

        if (this.feed.dataset.built === key) return;
        this.feed.dataset.built = key;
        this.feed.innerHTML = '';

        items.forEach(function (item) {
          var slide = document.createElement('div');
          slide.className = 'cham-reelviewer__slide';

          var video = document.createElement('video');
          video.className = 'cham-reelviewer__video';
          video.src = item.src;
          if (item.poster) video.poster = item.poster;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.preload = 'metadata';
          slide.appendChild(video);

          var paused = document.createElement('span');
          paused.className = 'cham-reelviewer__paused';
          paused.innerHTML =
            '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="6 3 20 12 6 21 6 3"/></svg>';
          slide.appendChild(paused);

          if (item.label) {
            var label = document.createElement('span');
            label.className = 'cham-reelviewer__label';
            label.textContent = item.label;
            slide.appendChild(label);
          }

          video.addEventListener('play', function () {
            slide.setAttribute('data-paused', 'false');
          });
          video.addEventListener('pause', function () {
            slide.setAttribute('data-paused', 'true');
          });
          video.addEventListener('click', function () {
            if (video.paused) video.play().catch(function () {});
            else video.pause();
          });

          self.feed.appendChild(slide);
        });

        if (this.observer) this.observer.disconnect();
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target.querySelector('video');
              if (entry.intersectionRatio >= 0.6) {
                self.activate(self.slides().indexOf(entry.target), false);
              } else if (video) {
                video.pause();
              }
            });
          },
          { root: this.feed, threshold: [0, 0.6] }
        );

        this.slides().forEach(function (slide) {
          self.observer.observe(slide);
        });
      },

      open: function (items, index) {
        if (!items || !items.length) return;
        this.mount();
        this.build(items);

        this.items = items;
        this.index = Math.min(Math.max(index || 0, 0), items.length - 1);
        this.muted = false;
        this.lastFocus = document.activeElement;

        this.root.setAttribute('data-open', 'true');
        document.body.style.overflow = 'hidden';

        var single = items.length < 2;
        this.prevBtn.hidden = single;
        this.nextBtn.hidden = single;
        this.countEl.hidden = single;

        this.feed.scrollTop = this.index * this.feed.clientHeight;
        this.activate(this.index, true);
        this.root.querySelector('.cham-reelviewer__close').focus();
      },

      close: function () {
        if (!this.isOpen()) return;
        this.slides().forEach(function (slide) {
          var video = slide.querySelector('video');
          if (video) video.pause();
        });
        this.root.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      },

      activate: function (index, firstOpen) {
        if (index < 0) return;
        var self = this;
        this.index = index;

        var video = this.video();
        if (!video) return;

        video.muted = this.muted;
        video.play().catch(function () {
          // Opening straight into sound is a gesture-gated privilege the browser
          // may withhold. Rather than leave a dead frame, fall back to muted.
          if (firstOpen && !video.muted) {
            self.muted = true;
            video.muted = true;
            video.play().catch(function () {});
          }
          self.syncMute();
        });

        this.syncMute();
        this.countEl.textContent = this.index + 1 + ' / ' + this.slides().length;
      },

      syncMute: function () {
        var video = this.video();
        if (!video || !this.muteBtn) return;
        this.muteBtn.innerHTML = icon(video.muted ? 'muted' : 'sound');
        this.muteBtn.setAttribute('aria-label', video.muted ? LABELS.unmute : LABELS.mute);
      },

      step: function (direction) {
        if (!this.feed) return;
        this.feed.scrollBy({ top: direction * this.feed.clientHeight, behavior: 'smooth' });
      },

      toggleMute: function () {
        this.muted = !this.muted;
        var video = this.video();
        if (video) video.muted = this.muted;
        this.syncMute();
      },
    };

    window.ChamReels = {
      open: function (items, index) {
        viewer.open(items, index);
      },
      close: function () {
        viewer.close();
      },
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
